/* tslint:disable */
/* eslint-disable */
/**
 * FancyAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const GetStudentsTeachersR200ResponseInnerElaLevelingProgramEnum = {
    DevelopmentReadingAssessment: 'development_reading_assessment',
    FountasAndPinnell: 'fountas_and_pinnell',
    StarScaledScore: 'star_scaled_score',
    Freckle: 'freckle'
};
/**
 * @export
 */
export const GetStudentsTeachersR200ResponseInnerEnvironmentEnum = {
    UsInSchool: 'us_in_school',
    UsNoSchool: 'us_no_school',
    OutsideUs: 'outside_us'
};
/**
 * @export
 */
export const GetStudentsTeachersR200ResponseInnerIdentityProviderEnum = {
    Clever: 'clever',
    Csv: 'csv',
    ClassLink: 'class-link',
    ClassLinkRaw: 'class-link-raw',
    Renaissance: 'renaissance'
};
/**
 * @export
 */
export const GetStudentsTeachersR200ResponseInnerLeaderboardEnum = {
    Individual: 'individual',
    Team: 'team',
    NoLeaderboard: 'no_leaderboard'
};
/**
 * @export
 */
export const GetStudentsTeachersR200ResponseInnerRoleEnum = {
    Teacher: 'teacher',
    InstructionalCoach: 'instructional_coach',
    SpecialEducationTeacher: 'special_education_teacher',
    CurriculumCoordinator: 'curriculum_coordinator',
    DirectorOfCurriculum: 'director_of_curriculum',
    RtiCoordinator: 'rti_coordinator',
    TechCoordinator: 'tech_coordinator',
    DirectorOfTechnology: 'director_of_technology',
    AssistantPrincipal: 'assistant_principal',
    Principal: 'principal',
    AssociateSuperintendent: 'associate_superintendent',
    Superintendent: 'superintendent',
    OtherDistrictLevelAdministrator: 'other_district_level_administrator',
    Parent: 'parent',
    Student: 'student',
    Other: 'other'
};
/**
 * @export
 */
export const GetStudentsTeachersR200ResponseInnerSourceEnum = {
    Upload: 'upload',
    IdpSync: 'idp_sync',
    Manual: 'manual'
};
/**
 * @export
 */
export const GetStudentsTeachersR200ResponseInnerStudentNameSortFieldEnum = {
    FirstName: 'first_name',
    LastName: 'last_name'
};
/**
 * Check if a given object implements the GetStudentsTeachersR200ResponseInner interface.
 */
export function instanceOfGetStudentsTeachersR200ResponseInner(value) {
    if (!('canChangeEmail' in value) || value['canChangeEmail'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    if (!('email' in value) || value['email'] === undefined)
        return false;
    if (!('emailVerified' in value) || value['emailVerified'] === undefined)
        return false;
    if (!('firstName' in value) || value['firstName'] === undefined)
        return false;
    if (!('focusMode' in value) || value['focusMode'] === undefined)
        return false;
    if (!('googleOnly' in value) || value['googleOnly'] === undefined)
        return false;
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('idpManaged' in value) || value['idpManaged'] === undefined)
        return false;
    if (!('language' in value) || value['language'] === undefined)
        return false;
    if (!('lastName' in value) || value['lastName'] === undefined)
        return false;
    if (!('leaderboard' in value) || value['leaderboard'] === undefined)
        return false;
    if (!('mathStandardSetId' in value) || value['mathStandardSetId'] === undefined)
        return false;
    if (!('studentNameSortField' in value) || value['studentNameSortField'] === undefined)
        return false;
    if (!('teamMode' in value) || value['teamMode'] === undefined)
        return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined)
        return false;
    return true;
}
export function GetStudentsTeachersR200ResponseInnerFromJSON(json) {
    return GetStudentsTeachersR200ResponseInnerFromJSONTyped(json, false);
}
export function GetStudentsTeachersR200ResponseInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'canChangeEmail': json['canChangeEmail'],
        'classLinkTeacherId': json['classLinkTeacherId'] == null ? undefined : json['classLinkTeacherId'],
        'cleverTeacherId': json['cleverTeacherId'] == null ? undefined : json['cleverTeacherId'],
        'countryCode': json['countryCode'] == null ? undefined : json['countryCode'],
        'createdAt': (new Date(json['createdAt'])),
        'deletedAt': json['deletedAt'] == null ? undefined : (new Date(json['deletedAt'])),
        'elaLevelingProgram': json['elaLevelingProgram'] == null ? undefined : json['elaLevelingProgram'],
        'elaStandardSetId': json['elaStandardSetId'] == null ? undefined : json['elaStandardSetId'],
        'email': json['email'],
        'emailVerified': json['emailVerified'],
        'environment': json['environment'] == null ? undefined : json['environment'],
        'firstName': json['firstName'],
        'focusMode': json['focusMode'],
        'googleOnly': json['googleOnly'],
        'gurId': json['gurId'] == null ? undefined : json['gurId'],
        'id': json['id'],
        'identityProvider': json['identityProvider'] == null ? undefined : json['identityProvider'],
        'idpManaged': json['idpManaged'],
        'language': json['language'],
        'lastName': json['lastName'],
        'leaderboard': json['leaderboard'],
        'mathStandardSetId': json['mathStandardSetId'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'renaissanceRPIdentifier': json['renaissanceRPIdentifier'] == null ? undefined : json['renaissanceRPIdentifier'],
        'role': json['role'] == null ? undefined : json['role'],
        'schoolId': json['schoolId'] == null ? undefined : json['schoolId'],
        'source': json['source'] == null ? undefined : json['source'],
        'studentNameSortField': json['studentNameSortField'],
        'teamMode': json['teamMode'],
        'updatedAt': (new Date(json['updatedAt'])),
    };
}
export function GetStudentsTeachersR200ResponseInnerToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'canChangeEmail': value['canChangeEmail'],
        'classLinkTeacherId': value['classLinkTeacherId'],
        'cleverTeacherId': value['cleverTeacherId'],
        'countryCode': value['countryCode'],
        'createdAt': ((value['createdAt']).toISOString()),
        'deletedAt': value['deletedAt'] == null ? undefined : (value['deletedAt'].toISOString()),
        'elaLevelingProgram': value['elaLevelingProgram'],
        'elaStandardSetId': value['elaStandardSetId'],
        'email': value['email'],
        'emailVerified': value['emailVerified'],
        'environment': value['environment'],
        'firstName': value['firstName'],
        'focusMode': value['focusMode'],
        'googleOnly': value['googleOnly'],
        'gurId': value['gurId'],
        'id': value['id'],
        'identityProvider': value['identityProvider'],
        'idpManaged': value['idpManaged'],
        'language': value['language'],
        'lastName': value['lastName'],
        'leaderboard': value['leaderboard'],
        'mathStandardSetId': value['mathStandardSetId'],
        'phoneNumber': value['phoneNumber'],
        'renaissanceRPIdentifier': value['renaissanceRPIdentifier'],
        'role': value['role'],
        'schoolId': value['schoolId'],
        'source': value['source'],
        'studentNameSortField': value['studentNameSortField'],
        'teamMode': value['teamMode'],
        'updatedAt': ((value['updatedAt']).toISOString()),
    };
}
